import React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgArrowRight = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="m24.244 14.62-7.875 7.874a.876.876 0 0 1-1.238-1.238l6.382-6.381H4.375a.875.875 0 0 1 0-1.75h17.138l-6.382-6.38a.876.876 0 0 1 1.238-1.24l7.875 7.876a.876.876 0 0 1 0 1.238Z" />
  </svg>
);
export default SvgArrowRight;
